import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PublicationSearchResult {
  id: string;
  title: string;
  translated_title?: string;
  excerpt: string;
  translated_excerpt?: string;
  slug: string;
  translated_slug?: string;
  featured_image_url: string | null;
  published_at: string;
  author_name: string;
  author_vanity_url: string | null;
  author_avatar: string | null;
  author_country: string | null;
  author_id: string;
}

interface SearchResponse {
  results: PublicationSearchResult[];
  query: string;
  translated_query?: string;
  total: number;
}

export const usePublicationSearch = (
  query: string,
  locale: string,
  options?: {
    enabled?: boolean;
    limit?: number;
    offset?: number;
  }
) => {
  const limit = options?.limit || 20;
  const offset = options?.offset || 0;
  const enabled = options?.enabled !== false && query.trim().length >= 2;

  return useQuery<SearchResponse>({
    queryKey: ['publication-search', query, locale, limit, offset],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('search-publications', {
        body: { query, locale, limit, offset }
      });

      if (error) throw error;
      return data;
    },
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};
